import { render, staticRenderFns } from "./ConventionTeaserTitle.vue?vue&type=template&id=0a3d3459&scoped=true"
import script from "./ConventionTeaserTitle.vue?vue&type=script&lang=js"
export * from "./ConventionTeaserTitle.vue?vue&type=script&lang=js"
import style0 from "./ConventionTeaserTitle.vue?vue&type=style&index=0&id=0a3d3459&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3d3459",
  null
  
)

export default component.exports